export enum Pages {
    EINZELABFRAGE = 'EINZELABFRAGE',
    EINZELABFRAGE_ERGEBNIS = 'EINZELABFRAGE_ERGEBNIS',
    VAEM = 'VAEM',
    VAEM_ERGEBNIS = 'VAEM_ERGEBNIS',
    TECHNISCHER_FEHLER = 'TECHNISCHER_FEHLER',
    BEZUEGESTELLE_FEHLER = 'BEZUEGESTELLE_FEHLER'
}

export type Page = Pages;

export const Routes = {};
Routes[Pages.EINZELABFRAGE] = { path: '/odbs/einzelabfrage', title: 'Einzelabfrage' };
Routes[Pages.EINZELABFRAGE_ERGEBNIS] = { path: '/odbs/einzelabfrage/ergebnis', title: 'Einzelabfrage-Ergebnis' };
Routes[Pages.VAEM] = { path: '/odbs/veraenderungsmitteilung', title: 'Veraenderungsmitteilung' };
Routes[Pages.VAEM_ERGEBNIS] = {
    path: '/odbs/veraenderungsmitteilung/ergebnis',
    title: 'Veraenderungsmitteilung-Ergebnis',
};
Routes[Pages.BEZUEGESTELLE_FEHLER] = { path: '/odbs/bezuegestelle-fehler', title: 'Bezügestelle Fehler' };
Routes[Pages.TECHNISCHER_FEHLER] = { path: '/ups', title: 'Technischer Fehler ODBS' };
